import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const ytCmsStaticsData = {
  menuTitle: MenuTitle.YoutubeCMS
};
export const Route = createFileRoute('/_private-routes/youtube-cms')({
  staticData: ytCmsStaticsData
});
